exports.agnes = require('./agnes');
exports.diana = require('./diana');
//exports.birch = require('./birch');
//exports.cure = require('./cure');
//exports.chameleon = require('./chameleon');



//////////////////
// WEBPACK FOOTER
// ./~/ml-hclust/src/index.js
// module id = 47
// module chunks = 0